<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tltip">
          <div v-on="tltip.on">
            <v-btn small icon color="primary" v-on="on">
              <v-icon color="secondary" v-if="marker.qrId">fa-qrcode</v-icon>
              <v-icon color="error" v-else>fa-qrcode</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{$t("addQRCode")}}</span>
      </v-tooltip>
    </template>
    <v-card v-if="dialog">
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("addQRCode")}}</v-tab>
        <v-tab-item>
          <qrcode-stream @decode="onDecode"></qrcode-stream>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="warning" max-width="500px">
          <v-card>
            <v-alert :value="true" type="warning">{{$t('overrideQRId')}}</v-alert>

            <v-card-text>{{$t('overrideQRId')}}</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="primary" text @click="warning = false">{{$t('close')}}</v-btn>

              <v-btn color="primary" text @click="getMarkerByQRId(qrId)">{{$t('save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="warning2" max-width="500px">
          <v-card>
            <v-alert :value="true" type="warning">{{$t('qrIdExists')}}</v-alert>

            <v-card-text>{{$t('qrIdExists')}}</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="warning2 = false">{{$t('close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="warning4" max-width="500px">
          <v-card>
            <v-alert :value="true" type="warning">{{$t('cached')}}</v-alert>

            <v-card-text>{{$t('cached')}}</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="warning4 = false">{{$t('close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="warning3" max-width="500px">
          <v-card>
            <v-alert :value="true" type="warning">{{$t('sameCode')}}</v-alert>

            <v-card-text>{{$t('sameCode')}}</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="warning3 = false">{{$t('close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="success" max-width="500px">
          <v-card>
            <v-alert :value="true" type="success">{{$t('success')}}</v-alert>

            <v-card-text>{{$t('success')}}</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="success = false">{{$t('close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: "addQRCode",
  data: () => ({
    show: false,
    dialog: false,
    warning: false,
    warning2: false,
    warning3: false,
    warning4: false,
    success: false,
    qrId: ""
  }),
  props: {
    marker: Object
  },
  methods: {
    close() {
      this.dialog = false;
    },
    onDecode(url) {
      this.$store.state.markersReadonly = [];
      this.qrId = url.substr(url.lastIndexOf("/") + 1);
      if (this.$validator.isUUID(this.qrId)) {
        if (this.marker.qrId && this.marker.qrId != this.qrId) {
          this.warning = true;
        } else if (this.marker.qrId && this.marker.qrId == this.qrId) {
          this.warning3 = true;
        } else {
          this.getMarkerByQRId(this.qrId);
        }
      } else {
      }
    },
    getMarkerByQRId(id) {
      let markerId = this.$route.params.id;
      if (this.$store.state.isOffline) {
        let o = {
          markerId: markerId,
          qrId: id
        };
        if (
          this.$store.state.offQrs.find(x => x.qrId == id) ||
          this.$store.state.markers.find(x => x.qrId == id)
        ) {
          this.warning2 = true;
        } else {
          this.marker.qrId = id;
          this.warning4 = true;
          this.success = true;
          this.dialog = false;
          this.$emit("updateMarker")
        }
      } else {
        this.$http
          .getMarkerByQRId(id, markerId)
          .then(res => {
            this.marker.qrId = id;
            this.warning = false;
            this.success = true;
            this.dialog = false;
          })
          .catch(err => {
            this.warning2 = true;
          });
      }
    }
  },
  created() {}
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Markers/AddQRCode.vue